import { paramsFromRecord } from '@common-lib';

export const routes = {
  auth: {
    login: '/login',
    signUp: '/sign-up',
    forgotPassword: '/forgot-password',
    changePasswordOnLogin: (changePasswordId: string) =>
      `/change-password${paramsFromRecord({ token: changePasswordId })}`,
    verifyEmail: '/verify-email',
  },
  welcome: '/welcome',
  landing: `/`,
  wallet: {
    list: (accountId?: string) => `/wallet/${paramsFromRecord({ accountId })}`,
    transaction: (accountId: string, transactionId: string) =>
      `/wallet/account/${accountId}/${transactionId}`,
  },
  news: (newsId?: string) => `/news${paramsFromRecord({ newsId })}`,
  home: `/home`,
  profile: {
    profile: '/profile',
    siteAccess: '/profile/site-access',
    changePassword: '/profile/change-password',
    notifications: '/profile/notifications',
    delete: '/profile/delete',
  },
  siteUnits: {
    sites: '/sites',
    site: (siteUnitId: string, single: boolean) =>
      `/sites/${siteUnitId}${paramsFromRecord({ single: single ? '1' : '' })}`,
    news: (siteUnitId: string, newsId?: string) =>
      `/sites/${siteUnitId}/news${paramsFromRecord({ newsId })}`,
    places: (siteUnitId: string, shopId: string) =>
      `/sites/${siteUnitId}/places/${shopId}`,
    menu: (siteUnitId: string, shopId: string, placeId: string) =>
      `/sites/${siteUnitId}/places/${shopId}/menu/${placeId}`,
  },
  topup: {
    topup: (accountId: string, error?: boolean) =>
      `/topup/${accountId}${paramsFromRecord({ error: error ? 'true' : '' })}`,
  },
  payment: {
    payment: (orderType: string, orderId: string, accountId: string) =>
      `/payment/${orderType}/${orderId}${paramsFromRecord({ accountId })}`,
  },
  benefits: '/benefits',
  notFound: '/not-found',
};
